module.exports = __webpack_public_path__ + "img/slideVerify_05.28eb2f38.png";